import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { DraftManagerService } from '../draft-manager.service';
import { DraftSelectService } from '../draft-select.service';

@Component({
  selector: 'app-champion-list-member',
  templateUrl: './champion-list-member.component.html',
  styleUrls: ['./champion-list-member.component.scss']
})
export class ChampionListMemberComponent implements OnInit {

  /** @var {ElementRef} container['nativeElement'] grants referenece to the HTMLElement of this component's container */
  @ViewChild("container", {static: false, read: ElementRef }) container: ElementRef;
  /** @var {string} The ID of the champion that this ChampionListMember represents */
  id: string;
  /** @var {string} The name of the champion that this ChampionListMember represents */
  name: string;
  /** @var {string} Can this member be selected */
  available: boolean = true;



  constructor(
    private draftManagerService: DraftManagerService,
    private draftSelectService: DraftSelectService
  ) { }



  ngOnInit() {
    // Subscribe to changes in picks
    this.draftManagerService.draft.subscribe((draft: {}) => {
      if (Object.values(draft['picks']).indexOf(this.id) > -1)
        this.available = false;
      else if (Object.values(draft['bans']).indexOf(this.id) > -1)
        this.available = false;
      else 
        this.available = true;
    });
  }

  ngAfterViewInit() {
    // Subscribe to selection
    this.draftSelectService.selection.subscribe((selection: any[]) => {
      if (this.draftSelectService.isSelected(this))
        this.container.nativeElement.classList.add("highlight");
      else
        this.container.nativeElement.classList.remove("highlight");
    });
  }


  onClick() {
    this.draftSelectService.select(this);
  }



  public getId(): string {
    return this.id;
  }

  public setId(id: string) {
    this.id = id;
  }

  public getName(): string {
    return this.name;
  }

  public setName(name: string) {
    this.name = name;
  }

  public getAvailable(): boolean {
    return this.available;
  }

  public setAvailable(available: boolean) {
    this.available = available;
  }

  public getClassName(): string {
    return "ChampionListMemberComponent";
  }

}
